import React, {useEffect, useState} from 'react';
import ScaleWrapper from "../../components/Wrappers/ScaleWrapper";
import ScreenWrapper from "../../components/Wrappers/ScreenWrapper";
import WebApp from "@twa-dev/sdk";
import Loader from "../../components/Loader";
import {fetchCodeAttempts, fetchCodes} from "../../store/codesSlice";
import {initNotification} from "../../store/notificationSlice";
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";
import AnimationBlock from "../../components/CodesScreen/AnimationBlock";
import TutorialCodeBody from "../../components/tutorial/TutorialCodeBody";



const CodesScreen: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const dispatch = useAppDispatch();
    const {status: codesStatus, error: codesError} = useAppSelector((state) => state.codes)

    useEffect(() => {
        WebApp.HapticFeedback.impactOccurred('soft');
        const body = document.querySelector('body');
        body?.classList.add('codes-screen');
        return () => {
            body?.classList.remove('codes-screen');
        }
    }, []);

    useEffect(() => {
        if(codesStatus === 'idle') {
            const fetchCodesAndAttemptsAsync = async () => {
                await dispatch(fetchCodes()).then(res => {
                    dispatch(fetchCodeAttempts());
                });
            }
            fetchCodesAndAttemptsAsync();
        }  else if(['fulfilled','fulfilled_max','fulfilled_incorrect','fulfilled_correct'].includes(codesStatus)) {
            setLoading(false)
        } else if(codesStatus === 'rejected') {
            dispatch(initNotification({data: {message: codesError, type:'error',show: true}}))
        }
    }, [dispatch, codesError, codesStatus]);

    return (
        <ScreenWrapper>
            <Loader loading={loading} duration={300}>
                <AnimationBlock/>
                <ScaleWrapper height="100%">
                    <TutorialCodeBody/>
                </ScaleWrapper>
            </Loader>
        </ScreenWrapper>
    );
};

export default CodesScreen;
